// @ts-nocheck
// update multiple fields...
export const UPDATE_MULTIPLE_FIELDS_AUTH = "UPDATE_MULTIPLE_FIELDS_AUTH";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

// // freelance login request
// export const FREELANCE_LOGIN_REQUEST = "FREELANCE_LOGIN_REQUEST";
// export const FREELANCE_LOGIN_SUCCESS = "FREELANCE_LOGIN_SUCCESS";
// export const FREELANCE_LOGIN_FAILURE = "FREELANCE_LOGIN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const UPDATE_USER_DATA = "UPDATE_USER_DATA";

export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";

// send otp to email
export const SEND_OTP_REQUEST = "SEND_OTP_REQUEST";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAILURE = "SEND_OTP_FAILURE";

// verify otp for forget password
export const VERIFY_FORGET_OTP_REQUEST = "VERIFY_FORGET_OTP_REQUEST";
export const VERIFY_FORGET_OTP_SUCCESS = "VERIFY_FORGET_OTP_SUCCESS";
export const VERIFY_FORGET_OTP_FAILURE = "VERIFY_FORGET_OTP_FAILURE";

// fetch user profile details
export const FETCH_USER_PROFILE_DETAILS_REQUEST =
  "FETCH_USER_PROFILE_DETAILS_REQUEST";
export const FETCH_USER_PROFILE_DETAILS_SUCCESS =
  "FETCH_USER_PROFILE_DETAILS_SUCCESS";
export const FETCH_USER_PROFILE_DETAILS_FAILURE =
  "FETCH_USER_PROFILE_DETAILS_FAILURE";

// set 2FA
export const SET_2FA_REQUEST = "SET_2FA_REQUEST";
export const SET_2FA_SUCCESS = "SET_2FA_SUCCESS";
export const SET_2FA_FAILURE = "SET_2FA_FAILURE";

// refresh token
export const REFRESH_TOKEN = "REFRESH_TOKEN";

// alert Dialog
export const ALERT_DIALOG = "ALERT_DIALOG";
export const ALERT_DIALOG_CLOSE = "ALERT_DIALOG_CLOSE";
export const ALERT_DIALOG_LOADING = "ALERT_DIALOG_LOADING";

// refresh user
export const REFRESH_USER = "REFRESH_USER";

// chnage notification prefrence toggle
export const CHANGE_NOTIFICATION_REQUEST = "CHANGE_NOTIFICATION_REQUEST";
export const CHANGE_NOTIFICATION_SUCCESS = "CHANGE_NOTIFICATION_SUCCESS";
export const CHANGE_NOTIFICATION_FAILURE = "CHANGE_NOTIFICATION_FAILURE";

// chnage push notification prefrence toggle
export const CHANGE_PUSH_NOTIFICATION_REQUEST =
  "CHANGE_PUSH_NOTIFICATION_REQUEST";
export const CHANGE_PUSH_NOTIFICATION_SUCCESS =
  "CHANGE_PUSH_NOTIFICATION_SUCCESS";
export const CHANGE_PUSH_NOTIFICATION_FAILURE =
  "CHANGE_PUSH_NOTIFICATION_FAILURE";

// forget password requests
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";

// change password
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

// update profile image
export const UPDATE_IMAGE_REQUEST = "UPDATE_IMAGE_REQUEST";
export const UPDATE_IMAGE_SUCCESS = "UPDATE_IMAGE_SUCCESS";
export const UPDATE_IMAGE_FAILURE = "UPDATE_IMAGE_FAILURE";

// fetch contractor user profile
export const FETCH_CONTRACTOR_PROFILE_REQUEST =
  "FETCH_CONTRACTOR_PROFILE_REQUEST";
export const FETCH_CONTRACTOR_PROFILE_SUCCESS =
  "FETCH_CONTRACTOR_PROFILE_SUCCESS";
export const FETCH_CONTRACTOR_PROFILE_FAILURE =
  "FETCH_CONTRACTOR_PROFILE_FAILURE";

// contractor profile steps
export const UPDATE_CONTRACTOR_PROFILE_STEPS =
  "UPDATE_CONTRACTOR_PROFILE_STEPS";

// delete account handler

// add contractor in bulk...
export const CREATE_CONTRACTORS_IN_BULK_REQUEST =
  "CREATE_CONTRACTORS_IN_BULK_REQUEST";
export const CREATE_CONTRACTORS_IN_BULK_SUCCESS =
  "CREATE_CONTRACTORS_IN_BULK_SUCCESS";
export const CREATE_CONTRACTORS_IN_BULK_FAILURE =
  "CREATE_CONTRACTORS_IN_BULK_FAILURE";
// add contractor in bulk...

// update contractor certificates...
export const UPDATE_CONTRACTOR_CERTIFICATES = "UPDATE_CONTRACTOR_CERTIFICATES";
// update contractor certificates...

// Multi-role: switch active role (mudar UI/interface ativa)
export const SWITCH_ACTIVE_ROLE_REQUEST = "SWITCH_ACTIVE_ROLE_REQUEST";
export const SWITCH_ACTIVE_ROLE_SUCCESS = "SWITCH_ACTIVE_ROLE_SUCCESS";
export const SWITCH_ACTIVE_ROLE_FAILURE = "SWITCH_ACTIVE_ROLE_FAILURE";

// toggle help status
export const TOGGLE_HELP_STATUS = "TOGGLE_HELP_STATUS";

// accept contractor consent
export const ACCEPT_CONTRACTOR_CONSENT_REQUEST =
  "ACCEPT_CONTRACTOR_CONSENT_REQUEST";
export const ACCEPT_CONTRACTOR_CONSENT_SUCCESS =
  "ACCEPT_CONTRACTOR_CONSENT_SUCCESS";
export const ACCEPT_CONTRACTOR_CONSENT_FAILURE =
  "ACCEPT_CONTRACTOR_CONSENT_FAILURE";

// client signup
export const CLIENT_SIGNUP_REQUEST = "CLIENT_SIGNUP_REQUEST";
export const CLIENT_SIGNUP_SUCCESS = "CLIENT_SIGNUP_SUCCESS";
export const CLIENT_SIGNUP_FAILURE = "CLIENT_SIGNUP_FAILURE";

// reset auth
export const RESET_AUTH = "RESET_AUTH";

// update email status
export const UPDATE_EMAIL_PREFERENECE_STATUS_REQUEST =
  "UPDATE_EMAIL_PREFERENECE_STATUS_REQUEST";
export const UPDATE_EMAIL_PREFERENECE_STATUS_SUCCESS =
  "UPDATE_EMAIL_PREFERENECE_STATUS_SUCCESS";
export const UPDATE_EMAIL_PREFERENECE_STATUS_FAILURE =
  "UPDATE_EMAIL_PREFERENECE_STATUS_FAILURE";

// fetch profile success
export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";

// firebase support status
export const FIREBASE_SUPPORT_STATUS = "FIREBASE_SUPPORT_STATUS";

// accept contractor documents
export const ACCEPT_CONTRACTOR_DOCUMENTS_REQUEST =
  "ACCEPT_CONTRACTOR_DOCUMENTS_REQUEST";
export const ACCEPT_CONTRACTOR_DOCUMENTS_SUCCESS =
  "ACCEPT_CONTRACTOR_DOCUMENTS_SUCCESS";
export const ACCEPT_CONTRACTOR_DOCUMENTS_FAILURE =
  "ACCEPT_CONTRACTOR_DOCUMENTS_FAILURE";